var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.source,attrs:{"id":"app"}},[[_c('vue-aliplayer-v2',{ref:"VueAliplayerV2",staticStyle:{"height":"100%"},attrs:{"id":"player-1194076936807170050","source":_vm.source,"options":_vm.options},on:{"ended":_vm.onEnded,"completeSeek":_vm.onCompleteSeek}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }